import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "list" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No tasks yet :| ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_Task = _resolveComponent("Task")!
  const _component_Box = _resolveComponent("Box")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Form, { onOnSaveTask: _ctx.saveTask }, null, 8, ["onOnSaveTask"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taskItems, (task, index) => {
        return (_openBlock(), _createBlock(_component_Task, {
          key: index,
          task: task
        }, null, 8, ["task"]))
      }), 128)),
      (_ctx.isListEmpty)
        ? (_openBlock(), _createBlock(_component_Box, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}